import { useCallback, Fragment } from 'react';
import type { Chat } from '@trinity/chat';
import { ChatAttachmentType } from '@trinity/chat';
import { HCPSearchAttachment } from '@trinity/chat-components/components/Chat.Attachments/HcpSearch';
import { SuggestedActionsAttachment } from '@trinity/chat-components/components/Chat.Attachments/Message.SuggestedActions';

type Props = {
  attachments: Chat.Attachment.Item[];
  className?: string;
};

export const ChatMessageAttachments = (props: Props) => {
  const renderAttachment = useCallback((attachment: Chat.Attachment.Item) => {
    switch (attachment.type) {
      case ChatAttachmentType.SuggestedActions:
        return <SuggestedActionsAttachment item={attachment} />;
      case ChatAttachmentType.HCPSearch:
        return <HCPSearchAttachment item={attachment} />;
      default:
        return null;
    }
  }, []);

  return (
    <div className={props.className}>
      {props.attachments.map((attachment, i) => (
        <Fragment key={i}>{renderAttachment(attachment)}</Fragment>
      ))}
    </div>
  );
};
